import React from "react";
import PropTypes, { InferProps } from "prop-types";

export function RadialBarChartCircle(props: InferProps<typeof RadialBarChartCircle.propTypes>) {
  const strokeWidthBackground = 3;
  const strokeWidthCore = props.showCoreOnly ? 3 : 2.5;
  const strokeWidthPrePost = props.showCoreOnly ? 0 : 1.25;

  const radiusPre = props.Radius - strokeWidthPrePost * 1.5;
  const radiusCore = props.Radius;
  const radiusPost = props.Radius + strokeWidthPrePost * 1.5;

  const factorPre = (2 * Math.PI * radiusPre) / 100;
  const factorCore = (2 * Math.PI * radiusCore) / 100;
  const factorPost = (2 * Math.PI * radiusPost) / 100;

  return (
    <>
      {/* Background */}
      <circle cx="50" cy="50" r={radiusCore} stroke="#EEEEEE" strokeWidth={strokeWidthBackground} fill="none" />

      {/* Circles */}
      <circle
        onMouseEnter={() => (props.onEnter ? props.onEnter("vorangehend") : null)}
        onMouseLeave={() => (props.onLeave ? props.onLeave() : null)}
        cx="50"
        cy="50"
        r={radiusPre}
        stroke={props.ColorPre}
        strokeWidth={strokeWidthPrePost}
        fill="none"
        strokeDasharray={factorPre * props.PercentagePre + " " + factorPre * 100}
        transform="rotate(90 50 50)"
      />
      <circle
        onMouseEnter={() => (props.onEnter ? props.onEnter("grundanspruch") : null)}
        onMouseLeave={() => (props.onLeave ? props.onLeave() : null)}
        cx="50"
        cy="50"
        r={radiusCore}
        stroke={props.ColorCore}
        strokeWidth={strokeWidthCore}
        fill="none"
        strokeDasharray={factorCore * props.PercentageCore + " " + factorCore * 100}
        transform="rotate(90 50 50)"
      />
      <circle
        onMouseEnter={() => (props.onEnter ? props.onEnter("weiterfuehrend") : null)}
        onMouseLeave={() => (props.onLeave ? props.onLeave() : null)}
        cx="50"
        cy="50"
        r={radiusPost}
        stroke={props.ColorPost}
        strokeWidth={strokeWidthPrePost}
        fill="none"
        strokeDasharray={factorPost * props.PercentagePost + " " + factorPost * 100}
        transform="rotate(90 50 50)"
      />
    </>
  );
}

RadialBarChartCircle.propTypes = {
  showCoreOnly: PropTypes.bool.isRequired,
  Radius: PropTypes.number.isRequired,

  PercentagePre: PropTypes.number.isRequired,
  PercentageCore: PropTypes.number.isRequired,
  PercentagePost: PropTypes.number.isRequired,

  ColorPre: PropTypes.string.isRequired,
  ColorCore: PropTypes.string.isRequired,
  ColorPost: PropTypes.string.isRequired,

  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
};

export default RadialBarChartCircle;
